import axios from "axios";

const EBRIDGE_BASE_URL = "https://assarainrpa.edata.ae/api/v1";
const EBRIDGE_API_KEY = process.env.REACT_APP_EBRIDGE_API_KEY;

const ebridgeHeaders = {
  "Content-Type": "application/json",
  "X-Api-Key": EBRIDGE_API_KEY,
};

export const getEbridgeQuotesService = async (data, signal) => {
  const response = await axios.post(`${EBRIDGE_BASE_URL}/quotes`, data, {
    headers: ebridgeHeaders,
    signal,
  });
  return response.data;
};

export const getEbridgeQuoteByTargetService = async (targetCode, data) => {
  const response = await axios.post(
    `${EBRIDGE_BASE_URL}/quotes/${targetCode}`,
    data,
    { headers: ebridgeHeaders }
  );
  return response.data;
};

// POST /policies/{targetCode} — not required for now
// export const createEbridgePolicyService = async (targetCode, data) => {
//   const response = await axios.post(
//     `${EBRIDGE_BASE_URL}/policies/${targetCode}`,
//     data,
//     { headers: ebridgeHeaders }
//   );
//   return response.data;
// };
